import {
  cycleCountIdFormat,
  cycleCountRuleIdFormat,
  locationIdFormat,
} from "@redotech/redo-inventory-id";
import { AdvancedFilterDataSchema } from "@redotech/redo-views-common/advanced-filters/advanced-filter-data";
import { taskIdFormat } from "@redotech/redo-warehouse-id";
import { unaryRpc } from "@redotech/rpc/definition";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const cycleCountStatusSchema = createEnum([
  "todo",
  "in_progress",
  "needs_review",
  "completed",
  "cancelled",
]);
export const cycleCountSourceSchema = createEnum(["auto", "manual"]);

const item = z.object({
  id: cycleCountIdFormat.schema,
  taskId: taskIdFormat.schema.nullable(),
  name: z.string().nullable(),
  status: cycleCountStatusSchema,
  source: cycleCountSourceSchema,
  locationId: locationIdFormat.schema,
  locationName: z.string(),
  cycleCountRuleId: cycleCountRuleIdFormat.schema.nullable(),
  ruleName: z.string().nullable(),
  totalLines: z.int(),
  countedLines: z.int(),
  assignedRole: z.string().nullable(),
  assignedUserId: z.string().nullable(),
  dueAt: z.date().nullable(),
  createdAt: z.date(),
});

export const listCycleCounts = unaryRpc({
  name: "listCycleCounts" as const,
  input: z.object({
    search: z.string().optional(),
    advancedFiltersData: z.array(AdvancedFilterDataSchema).optional(),
    page: z.number().int().min(0).optional(),
    pageSize: z.number().int().min(1).max(100).optional(),
  }),
  output: z.object({ totalCount: z.number(), cycleCounts: z.array(item) }),
});
